import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { WeeklySchedule } from '../../models/serializable/weekly-schedule.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PoolWeeklyScheduleComponent extends Component {
  static readonly TYPE_ID: string = '5f2d0c1f81944faabbe6c22373499fbc';

  constructor(
        public readonly weeklySchedule: WeeklySchedule,
  ) {
    super();
  }

  get $typeId(): string {
    return PoolWeeklyScheduleComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PoolWeeklyScheduleComponent {
    return new PoolWeeklyScheduleComponent(
        context.fromData<WeeklySchedule>(MapUtils.getRaw(map, 'weeklySchedule') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'weeklySchedule': context.toData(this.weeklySchedule),
    };
  }

  clone(): this {
    return new PoolWeeklyScheduleComponent(
        this.weeklySchedule.clone(),
    ) as this;
  }

  isSame(other: PoolWeeklyScheduleComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.weeklySchedule, this.weeklySchedule);
  }
}

export class PoolWeeklyScheduleComponentBuilder extends DataModelBuilder<PoolWeeklyScheduleComponent> {
  build(context: SerializationContext, map: SerializedData): PoolWeeklyScheduleComponent {
    return PoolWeeklyScheduleComponent.fromMap(context, map);
  }
}
